"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = require("@headlessui/react");
var moment_1 = __importDefault(require("moment"));
var react_2 = __importStar(require("react"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var button_1 = require("../../action/button");
//TODO : Change Date Range for time + use own Date Picker
var DateRangeModal = /** @class */function (_super) {
  __extends(DateRangeModal, _super);
  function DateRangeModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      date: null
    };
    _this.renderTimeOptions = function () {
      var fromTime = (0, moment_1.default)().startOf("day");
      var toTime = (0, moment_1.default)().endOf("day");
      var duration = moment_1.default.duration(toTime.diff(fromTime));
      var diff = duration.hours();
      var timeList = [];
      for (var i = 0; diff >= i; i++) {
        var result = (0, moment_1.default)(fromTime).add(i, "hours").format("HH:mm");
        timeList.push({
          title: result,
          key: result
        });
      }
      return timeList;
    };
    return _this;
  }
  DateRangeModal.prototype.render = function () {
    var _this = this;
    return react_2.default.createElement(react_1.Transition.Root, {
      show: this.props.open,
      as: react_2.Fragment
    }, react_2.default.createElement(react_1.Dialog, {
      as: "div",
      static: true,
      className: "fixed z-10 inset-0 overflow-y-auto",
      open: this.props.open,
      onClose: this.props.onClose
    }, react_2.default.createElement("div", {
      className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    }, react_2.default.createElement(react_1.Transition.Child, {
      as: react_2.Fragment,
      enter: "ease-out duration-300",
      enterFrom: "opacity-0",
      enterTo: "opacity-100",
      leave: "ease-in duration-200",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0"
    }, react_2.default.createElement(react_1.Dialog.Overlay, {
      className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
    })), react_2.default.createElement("span", {
      className: "hidden sm:inline-block sm:align-middle sm:h-screen",
      "aria-hidden": "true"
    }, "\u200B"), react_2.default.createElement(react_1.Transition.Child, {
      as: react_2.Fragment,
      enter: "ease-out duration-300",
      enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      enterTo: "opacity-100 translate-y-0 sm:scale-100",
      leave: "ease-in duration-200",
      leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
      leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }, react_2.default.createElement("div", {
      className: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-10 text-left overflow-hidden shadow-xl transform transition-all w-full sm:my-8 sm:align-middle sm:max-w-lg sm:p-6"
    }, react_2.default.createElement("div", null, react_2.default.createElement("div", {
      className: "border-b border-gray-200 pb-4"
    }, react_2.default.createElement(react_1.Dialog.Title, {
      as: "h3",
      className: "text-lg leading-6 font-medium text-gray-900"
    }, "Select Date Range")), react_2.default.createElement("div", {
      className: "grid grid-cols-1 gap-5 pb-80 mt-4 sm:grid-cols-2"
    }, react_2.default.createElement("div", {
      className: "flex flex-col"
    }, react_2.default.createElement("div", {
      className: "font-medium text-sm  m-1"
    }, "Start Date"), react_2.default.createElement(react_datepicker_1.default, {
      dateFormat: "dd/MM/yy",
      selected: this.props.startDate,
      onChange: function (date) {
        _this.props.onChange(date, "startDate");
      },
      selectsStart: true,
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<"
    })), react_2.default.createElement("div", {
      className: "flex flex-col"
    }, react_2.default.createElement("div", {
      className: "font-medium text-sm  m-1 "
    }, "End Date"), react_2.default.createElement(react_datepicker_1.default, {
      dateFormat: "dd/MM/yy",
      selected: this.props.endDate,
      onChange: function (date) {
        _this.props.onChange(date, "endDate");
      },
      selectsStart: true,
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<"
    }), react_2.default.createElement("span", {
      className: "text-red-500 text-sm"
    }, this.props.dateRangeError))), react_2.default.createElement("div", {
      className: "flex flex-row justify-end"
    }, react_2.default.createElement(button_1.Button, {
      size: "small",
      text: "Cancel",
      className: "mr-4",
      type: "light",
      onClick: this.props.onClose
    }), react_2.default.createElement(button_1.Button, {
      size: "small",
      text: "Confirm",
      type: "normal",
      onClick: this.props.onClick
    }))))))));
  };
  return DateRangeModal;
}(react_2.Component);
exports.default = DateRangeModal;